// Paths where the public header / footer are hidden. Matching is by `startsWith`,
// so include both the trailing-slash and non-trailing-slash forms where needed.

const HEADER_HIDDEN_PATHS = [
  "/login",
  "/login/",
  "/login/individuals",
  "/login/individuals/",
  "/signup/individuals",
  "/signup/individuals/",
  "/signup/tokens",
  "/signup/tokens/",
  "/es-ES/login",
  "/es-ES/login/",
  "/es-ES/login/individuals",
  "/es-ES/login/individuals/",
  "/es-ES/signup/individuals",
  "/es-ES/signup/individuals/",
  "/es-ES/signup/tokens",
  "/es-ES/signup/tokens/",
  "/passwordless/authentication",
  "/passwordless/authentication/",
  "/educator/",
  "/educator",
  "/educator/students",
  "/educator/students/",
  "/educator/students/group/",
  "/educator/students/group",
  "/educator/staff",
  "/educator/staff/",
  "/educator/analytics",
  "/educator/analytics/",
  "/educator/analytics/report",
  "/educator/analytics/report/",
  "/profile/",
  "/certificates/",
  "/certificates",
]

// Additional header-hidden paths for prospective students
const HEADER_HIDDEN_PATHS_PROSPECTIVE_STUDENT = ["/dashboard", "/dashboard?", "/es-ES/dashboard", "/es-ES/dashboard/"]

const FOOTER_HIDDEN_PATHS = [
  "/login",
  "/login/",
  "/login/individuals",
  "/login/individuals/",
  "/signup/individuals",
  "/signup/individuals/",
  "/es-ES/login",
  "/es-ES/login/",
  "/es-ES/login/individuals",
  "/es-ES/login/individuals/",
  "/es-ES/signup/individuals",
  "/es-ES/signup/individuals/",
  "/signup/tokens",
  "/signup/tokens/",
  "/es-ES/signup/tokens",
  "/es-ES/signup/tokens/",
  "/passwordless/authentication",
  "/educator/",
  "/educator",
  "/educator/students",
  "/educator/students/",
  "/educator/students/group/",
  "/educator/students/group",
  "/educator/staff",
  "/educator/staff/",
  "/educator/analytics",
  "/educator/analytics/",
  "/admin/modules/create",
  "/admin/modules/create/",
  "/admin/programs/create",
  "/admin/programs/create/",
  "/admin/programs/edit",
  "/admin/programs/edit/",
  "/admin/modules/edit",
  "/admin/modules/edit/",
  "/tal-e/",
  "/tal-e",
  "/es-ES/tal-e/",
  "/es-ES/tal-e",
]

const matchesAny = (pathname = "", paths) => paths.some((path) => pathname.startsWith(path))

export const isHeaderVisible = (pathname, { isProspectiveStudent = false } = {}) => {
  if (isProspectiveStudent && matchesAny(pathname, HEADER_HIDDEN_PATHS_PROSPECTIVE_STUDENT)) {
    return false
  }
  return !matchesAny(pathname, HEADER_HIDDEN_PATHS)
}

export const isFooterVisible = (pathname) => !matchesAny(pathname, FOOTER_HIDDEN_PATHS)
